import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, createBlock as _createBlock, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f51d096"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "text-muted mb-3"
}
const _hoisted_3 = { class: "d-flex align-items-end gap-2 mb-4 flex-wrap" }
const _hoisted_4 = {
  class: "flex-grow-1",
  style: {"min-width":"16rem"}
}
const _hoisted_5 = {
  key: 1,
  class: "text-center py-10 text-muted"
}
const _hoisted_6 = { class: "mt-4" }
const _hoisted_7 = {
  key: 1,
  class: "step-scroll"
}
const _hoisted_8 = { class: "text-muted mb-3" }
const _hoisted_9 = { class: "border rounded p-4" }
const _hoisted_10 = { class: "row g-3" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = {
  key: 2,
  class: "step-scroll"
}
const _hoisted_17 = { class: "text-muted mb-3" }
const _hoisted_18 = { class: "border rounded p-4 mb-4" }
const _hoisted_19 = { class: "row g-3 align-items-end mb-3" }
const _hoisted_20 = { class: "col" }
const _hoisted_21 = { class: "col" }
const _hoisted_22 = { class: "col-auto" }
const _hoisted_23 = {
  key: 3,
  class: "don-vi-map-preview-placeholder"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  key: 4,
  class: "mt-3"
}
const _hoisted_27 = { class: "list-unstyled mb-0" }
const _hoisted_28 = { class: "mb-1" }
const _hoisted_29 = { class: "mb-1" }
const _hoisted_30 = { class: "mb-1" }
const _hoisted_31 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_32 = {
  key: 1,
  class: "mb-1"
}
const _hoisted_33 = {
  key: 3,
  class: "text-center py-12"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary mb-3",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 fw-semibold" }, "Đang đồng bộ đơn vị...", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted mb-0" }, "Vui lòng không đóng cửa sổ này.", -1))
const _hoisted_37 = [
  _hoisted_34,
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = { key: 4 }
const _hoisted_39 = { class: "list-unstyled mb-4" }
const _hoisted_40 = { class: "mb-2" }
const _hoisted_41 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "fs-6 fw-bold mb-2" }, "Tài khoản quản trị đã tạo", -1))
const _hoisted_43 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_44 = { class: "d-flex justify-content-end gap-2 w-100 flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LabelCustom = _resolveComponent("LabelCustom")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_DonViMapPreview = _resolveComponent("DonViMapPreview")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseModal = _resolveComponent("BaseModal")!

  return (_openBlock(), _createBlock(_component_BaseModal, {
    "is-display": _ctx.isOpen,
    title: _ctx.modalTitle,
    size: "xl",
    "show-footer": _ctx.step !== 'importing',
    "is-close-disabled": _ctx.step === 'importing',
    "close-on-backdrop-click": _ctx.step !== 'importing',
    "close-on-escape": _ctx.step !== 'importing',
    onClose: _ctx.onClose
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_44, [
        (_ctx.step === 'preview')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_ButtonCustom, {
                "button-type": _ctx.ButtonsType.CANCEL,
                "color-type": _ctx.ButtonTypeColors.SECONDARY,
                onClick: _ctx.onClose
              }, {
                "button-label": _withCtx(() => [
                  _createTextVNode("Hủy")
                ]),
                _: 1
              }, 8, ["button-type", "color-type", "onClick"]),
              _createVNode(_component_ButtonCustom, {
                "button-type": _ctx.ButtonsType.FORWARD,
                "color-type": _ctx.ButtonTypeColors.PRIMARY,
                "is-disabled": !_ctx.canContinueFromPreview,
                onClick: _ctx.onContinueFromPreview
              }, {
                "button-label": _withCtx(() => [
                  _createTextVNode("Tiếp tục")
                ]),
                _: 1
              }, 8, ["button-type", "color-type", "is-disabled", "onClick"])
            ], 64))
          : (_ctx.step === 'admins')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_ButtonCustom, {
                  "button-type": _ctx.ButtonsType.BACK,
                  "color-type": _ctx.ButtonTypeColors.SECONDARY,
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.step = 'preview'))
                }, {
                  "button-label": _withCtx(() => [
                    _createTextVNode("Quay lại")
                  ]),
                  _: 1
                }, 8, ["button-type", "color-type"]),
                _createVNode(_component_ButtonCustom, {
                  "button-type": _ctx.ButtonsType.FORWARD,
                  "color-type": _ctx.ButtonTypeColors.PRIMARY,
                  onClick: _ctx.onContinueFromAdmins
                }, {
                  "button-label": _withCtx(() => [
                    _createTextVNode("Tiếp tục")
                  ]),
                  _: 1
                }, 8, ["button-type", "color-type", "onClick"])
              ], 64))
            : (_ctx.step === 'geojson')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createVNode(_component_ButtonCustom, {
                    "button-type": _ctx.ButtonsType.BACK,
                    "color-type": _ctx.ButtonTypeColors.SECONDARY,
                    onClick: _ctx.onBackFromGeojson
                  }, {
                    "button-label": _withCtx(() => [
                      _createTextVNode("Quay lại")
                    ]),
                    _: 1
                  }, 8, ["button-type", "color-type", "onClick"]),
                  _createVNode(_component_ButtonCustom, {
                    "button-type": _ctx.ButtonsType.SAVE,
                    "color-type": _ctx.ButtonTypeColors.PRIMARY,
                    "is-disabled": !_ctx.canSubmitSync,
                    onClick: _ctx.onSubmitSync
                  }, {
                    "button-label": _withCtx(() => [
                      _createTextVNode("Đồng bộ")
                    ]),
                    _: 1
                  }, 8, ["button-type", "color-type", "is-disabled", "onClick"])
                ], 64))
              : (_ctx.step === 'result')
                ? (_openBlock(), _createBlock(_component_ButtonCustom, {
                    key: 3,
                    "button-type": _ctx.ButtonsType.DONE,
                    "color-type": _ctx.ButtonTypeColors.PRIMARY,
                    onClick: _ctx.onFinish
                  }, {
                    "button-label": _withCtx(() => [
                      _createTextVNode("Đóng")
                    ]),
                    _: 1
                  }, 8, ["button-type", "color-type", "onClick"]))
                : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.step === 'preview')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.previewMessage)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.previewMessage), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_LabelCustom, { "is-text-muted": false }, {
                  default: _withCtx(() => [
                    _createTextVNode("Lọc mã đơn vị (tuỳ chọn)")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.filterMaDonVi,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterMaDonVi) = $event)),
                  clearable: "",
                  placeholder: "Ví dụ: 0201,0204",
                  disabled: _ctx.isLoadingPreview,
                  onKeyup: _withKeys(_ctx.loadPreview, ["enter"])
                }, null, 8, ["modelValue", "disabled", "onKeyup"])
              ]),
              _createVNode(_component_ButtonCustom, {
                "button-type": _ctx.ButtonsType.REFRESH,
                "color-type": _ctx.ButtonTypeColors.SECONDARY,
                "is-loading": _ctx.isLoadingPreview,
                "is-disabled": _ctx.isLoadingPreview,
                onClick: _ctx.loadPreview
              }, {
                "button-label": _withCtx(() => [
                  _createTextVNode("Tải lại")
                ]),
                _: 1
              }, 8, ["button-type", "color-type", "is-loading", "is-disabled", "onClick"])
            ]),
            (_ctx.isLoadingPreview)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Đang tải danh sách đơn vị mới... "))
              : (_ctx.previewError)
                ? (_openBlock(), _createBlock(_component_el_alert, {
                    key: 2,
                    type: "error",
                    title: _ctx.previewError,
                    closable: false,
                    "show-icon": "",
                    class: "mb-3"
                  }, null, 8, ["title"]))
                : (!_ctx.newDonVi.length)
                  ? (_openBlock(), _createBlock(_component_el_alert, {
                      key: 3,
                      type: "info",
                      title: "Không có đơn vị mới từ hệ thống kế toán",
                      closable: false,
                      "show-icon": ""
                    }))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      _createVNode(_component_el_table, {
                        data: _ctx.newDonVi,
                        border: true,
                        size: "medium",
                        "max-height": "360",
                        "row-key": "ma_don_vi",
                        "highlight-current-row": "",
                        onRowClick: _ctx.onRowClick
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_table_column, {
                            label: "",
                            width: "52",
                            align: "center"
                          }, {
                            default: _withCtx((scope) => [
                              _createVNode(_component_el_radio, {
                                modelValue: _ctx.selectedMaDonVi,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedMaDonVi) = $event)),
                                label: scope.row.ma_don_vi,
                                onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("   ")
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "label"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "Mã ĐV",
                            prop: "ma_don_vi",
                            "min-width": "100"
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "Tên đơn vị",
                            prop: "ten_don_vi",
                            "min-width": "180"
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "Cấp",
                            width: "80",
                            align: "center"
                          }, {
                            default: _withCtx((scope) => [
                              _createTextVNode(_toDisplayString(_ctx.formatCapDonVi(scope.row.cap_don_vi)), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "Địa chỉ",
                            "min-width": "160"
                          }, {
                            default: _withCtx((scope) => [
                              _createTextVNode(_toDisplayString(scope.row.dia_chi || scope.row.dia_chi_goc || "-"), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "MST",
                            prop: "ma_so_thue",
                            "min-width": "110"
                          }, {
                            default: _withCtx((scope) => [
                              _createTextVNode(_toDisplayString(scope.row.ma_so_thue || "-"), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["data", "onRowClick"]),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_el_checkbox, {
                          modelValue: _ctx.syncNguoiDung,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.syncNguoiDung) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Đồng bộ người dùng từ kế toán ")
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ], 64))
          ]))
        : (_ctx.step === 'admins')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, [
                _createTextVNode(" Nhập tài khoản quản trị mặc định cho đơn vị "),
                _createElementVNode("strong", null, _toDisplayString(_ctx.selectedMaDonVi), 1),
                _createTextVNode(" — " + _toDisplayString(_ctx.selectedDonViName) + ". ", 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_LabelCustom, { "is-required": "" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Họ và tên")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.adminDraft.ho_va_ten,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.adminDraft.ho_va_ten) = $event)),
                      placeholder: "Họ và tên"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_LabelCustom, { "is-required": "" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Tên đăng nhập")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.adminDraft.ten_dang_nhap,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.adminDraft.ten_dang_nhap) = $event)),
                      placeholder: "Tên đăng nhập"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_LabelCustom, { "is-required": "" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Mật khẩu")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.adminDraft.mat_khau,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.adminDraft.mat_khau) = $event)),
                      type: "password",
                      "show-password": "",
                      placeholder: "Mật khẩu"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_LabelCustom, { "is-required": "" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Số điện thoại")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.adminDraft.so_dien_thoai,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.adminDraft.so_dien_thoai) = $event)),
                      placeholder: "Số điện thoại"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_LabelCustom, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Email (tuỳ chọn)")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.adminDraft.email,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.adminDraft.email) = $event)),
                      placeholder: "Email"
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ])
            ]))
          : (_ctx.step === 'geojson')
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("p", _hoisted_17, [
                  _createTextVNode(" Kiểm tra / chỉnh địa chỉ để xác định vị trí trước khi đồng bộ "),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.selectedMaDonVi), 1),
                  _createTextVNode(" — " + _toDisplayString(_ctx.selectedDonViName) + ". ", 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_LabelCustom, { "is-text-muted": false }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Địa chỉ gốc (kế toán) ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_input, {
                        "model-value": _ctx.diaChiGoc,
                        type: "textarea",
                        rows: 1,
                        disabled: ""
                      }, null, 8, ["model-value"])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_LabelCustom, { "is-required": "" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Địa chỉ bản đồ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.diaChi,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.diaChi) = $event)),
                        type: "textarea",
                        rows: 1,
                        placeholder: "Nhập hoặc sửa địa chỉ bản đồ",
                        onInput: _ctx.onDiaChiEdited
                      }, null, 8, ["modelValue", "onInput"])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_ButtonCustom, {
                        "button-type": _ctx.ButtonsType.LOCATION_DOT,
                        "color-type": _ctx.ButtonTypeColors.SUCCESS,
                        size: _ctx.ButtonSizeEnums.SMALL,
                        "is-loading": _ctx.isLoadingGeojson,
                        "is-disabled": _ctx.isLoadingGeojson || !_ctx.diaChi.trim(),
                        "tooltip-message": "Xem trước vị trí",
                        onClick: _ctx.requestGeojsonPreview
                      }, null, 8, ["button-type", "color-type", "size", "is-loading", "is-disabled", "onClick"])
                    ])
                  ]),
                  (_ctx.geojsonError)
                    ? (_openBlock(), _createBlock(_component_el_alert, {
                        key: 0,
                        type: "error",
                        title: _ctx.geojsonError,
                        closable: false,
                        "show-icon": "",
                        class: "mb-3"
                      }, null, 8, ["title"]))
                    : (_ctx.isGeojsonLocated)
                      ? (_openBlock(), _createBlock(_component_el_alert, {
                          key: 1,
                          type: "success",
                          title: "Đã xác định được vị trí",
                          closable: false,
                          "show-icon": "",
                          class: "mb-3"
                        }))
                      : _createCommentVNode("", true),
                  (_ctx.showMapPreview)
                    ? (_openBlock(), _createBlock(_component_DonViMapPreview, {
                        key: _ctx.mapPreviewKey,
                        latitude: _ctx.mapLatitude,
                        longitude: _ctx.mapLongitude,
                        label: _ctx.selectedDonViName
                      }, null, 8, ["latitude", "longitude", "label"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        (_ctx.isLoadingGeojson)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Đang tải vị trí..."))
                          : (_openBlock(), _createElementBlock("span", _hoisted_25, "Chưa có vị trí để hiển thị trên bản đồ"))
                      ])),
                  (_ctx.geojsonFeature)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("ul", _hoisted_27, [
                          _createElementVNode("li", _hoisted_28, [
                            _createTextVNode(" Địa chỉ bản đồ: "),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.geojsonFeature.properties.dia_chi || _ctx.diaChi), 1)
                          ]),
                          _createElementVNode("li", _hoisted_29, [
                            _createTextVNode(" Vĩ độ: "),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.formatCoord(_ctx.geojsonFeature.properties.latitude)), 1)
                          ]),
                          _createElementVNode("li", _hoisted_30, [
                            _createTextVNode(" Kinh độ: "),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.formatCoord(_ctx.geojsonFeature.properties.longitude)), 1)
                          ]),
                          (_ctx.geojsonFeature.properties.province_code)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_31, [
                                _createTextVNode(" Mã tỉnh: "),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.geojsonFeature.properties.province_code), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.geojsonFeature.properties.reason)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_32, [
                                _createTextVNode(" Lý do: "),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.geojsonFeature.properties.reason), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (_ctx.step === 'importing')
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_37))
              : (_ctx.step === 'result')
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createVNode(_component_el_alert, {
                      type: "success",
                      title: "Đồng bộ hoàn tất",
                      closable: false,
                      "show-icon": "",
                      class: "mb-4"
                    }),
                    _createElementVNode("ul", _hoisted_39, [
                      _createElementVNode("li", _hoisted_40, [
                        _createTextVNode(" Đơn vị đã nhập: "),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.resultSummary.importedCount), 1)
                      ]),
                      (_ctx.syncNguoiDung)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_41, [
                            _createTextVNode(" Người dùng đã đồng bộ: "),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.resultSummary.syncedUsersCount), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (!_ctx.syncNguoiDung && _ctx.resultSummary.admins.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_42,
                          _createVNode(_component_el_alert, {
                            type: "warning",
                            title: "Hãy lưu hoặc chia sẻ mật khẩu ngay — hệ thống có thể không hiển thị lại mật khẩu.",
                            closable: false,
                            "show-icon": "",
                            class: "mb-3"
                          }),
                          _createVNode(_component_el_table, {
                            data: _ctx.resultSummary.admins,
                            border: true,
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_table_column, {
                                label: "Mã ĐV",
                                prop: "ma_don_vi",
                                "min-width": "100"
                              }),
                              _createVNode(_component_el_table_column, {
                                label: "Tên đăng nhập",
                                prop: "ten_dang_nhap",
                                "min-width": "140"
                              }),
                              _createVNode(_component_el_table_column, {
                                label: "Mật khẩu",
                                "min-width": "140"
                              }, {
                                default: _withCtx((scope) => [
                                  _createTextVNode(_toDisplayString(scope.row.mat_khau || _ctx.adminDraft.mat_khau || "(đã nhập)"), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["data"])
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.resultSummary.firstDonViId)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                          _createVNode(_component_router_link, {
                            class: "text-primary",
                            to: {
            path: '/quan-ly/nguoi-dung/danh-sach',
            query: { id_don_vi: String(_ctx.resultSummary.firstDonViId) },
          }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Xem người dùng của đơn vị mới ")
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["is-display", "title", "show-footer", "is-close-disabled", "close-on-backdrop-click", "close-on-escape", "onClose"]))
}